import { ReducersTypes } from "constants/ReducersTypes";
import { getUXSettingsFromStorage } from "utils";
import { getLocaleString } from "utils/localization/locale";
import omit from "lodash/omit";

export const AUTOPAY_ACCOUNTS_COLUMNS = {
  [getLocaleString("common.customer", "Customer")]: true,
  [getLocaleString("reports.autopay_method", "Autopay Method")]: true,
  [getLocaleString("reports.autopay_enable_date", "Autopay Enable Date")]: true,
  [getLocaleString(
    "reports.upcoming_invoice_due_date",
    "Upcoming Invoice Due Date"
  )]: true,
  [getLocaleString("common.email", "Email")]: true,
};

export const AUTOPAY_ACCOUNTS_COLUMNS_ORDER = {
  Customer: 1,
  "Autopay Method": 2,
  "Autopay Enable Date": 3,
  "Upcoming Invoice Due Date": 4,
  Email: 5,
};

const savedFilters = getUXSettingsFromStorage(
  "ANALYTICS_AUTOPAY_ACCOUNTS_FILTERS"
);

export const initialAutopayAccountsFilters = {
  sort_by: "customer_name",
  sort_order: "asc",
  customerSelect: null,
  autopay_method: "",
};

const reducerInitialFilter = {
  ...initialAutopayAccountsFilters,
  page: 1,
  per_page: 20,
  ...savedFilters,
};

export const initialData = {
  listData: [],
  isFetching: false,
  filters: reducerInitialFilter,
  total: null,
  pagination: {
    next_num: null,
    pages: 1,
    prev_num: null,
  },
};

const autopayAccountsDetails = (state = initialData, { type, payload }) => {
  switch (type) {
    case ReducersTypes.AUTOPAY_ACCOUNTS_LIST_FETCHING:
      return {
        ...state,
        isFetching: true,
        listData: [],
      };

    case ReducersTypes.AUTOPAY_ACCOUNTS_LIST_RESET:
      return {
        listData: [],
        isFetching: true,
        total: null,
        filters: {
          ...(payload?.data?.filter || reducerInitialFilter),
          page: 1,
        },
        pagination: {
          next_num: null,
          pages: 1,
          prev_num: null,
        },
      };

    case ReducersTypes.AUTOPAY_ACCOUNTS_LIST_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
      };

    case ReducersTypes.AUTOPAY_ACCOUNTS_LIST:
      if (payload.data.filters?.is_export) {
        return state;
      }
      return {
        ...state,
        isFetching: false,
        listData: payload.data.result,
        filters: {
          ...omit(state.filters, ["is_export"]),
          ...omit(payload.data.filters, ["is_export"]),
        },
        total: payload.data.total,
        pagination: {
          next_num: payload.data.next_num,
          pages: payload.data.pages,
          prev_num: payload.data.prev_num,
        },
      };

    default:
      return state;
  }
};

export default autopayAccountsDetails;
